import {
  CODE_OF_CONDUCT_HEADING_TITLE,
  CONFLICT_OF_INTEREST_HEADING_TITLE,
  OTHER_ATTENDEES_HEADING_TITLE,
  UNUSUAL_CIRCUMSTANCES_HEADING_TITLE,
} from "../constants";

/**
 * The app-owned "preamble" sections that the Report Builder force-inserts as
 * heading-only stubs when the uploaded template doesn't already declare them.
 *
 * `value: ""` — heading only, no auto-inserted body (MDRS-140: experts author
 * the content themselves; for Code of Conduct they browse-and-copy from the CoC
 * panel). `applyModuleContent` tags each with `alwaysInsert` so the heading
 * lands even with a blank value, and skips any heading already present in the
 * template body (no duplicates).
 */
export type PreambleDefinition = {
  titles: readonly string[];
  headingLabel: string;
  value: string;
};

export const PREAMBLE_DEFINITIONS: readonly PreambleDefinition[] = [
  {
    titles: CODE_OF_CONDUCT_HEADING_TITLE,
    headingLabel: "CODE OF CONDUCT",
    value: "",
  },
  {
    titles: CONFLICT_OF_INTEREST_HEADING_TITLE,
    headingLabel: "CONFLICT OF INTEREST",
    value: "",
  },
  {
    titles: OTHER_ATTENDEES_HEADING_TITLE,
    headingLabel: "INTERPRETER AND/OR OTHER ATTENDEES",
    value: "",
  },
  {
    titles: UNUSUAL_CIRCUMSTANCES_HEADING_TITLE,
    headingLabel: "UNUSUAL CIRCUMSTANCES",
    value: "",
  },
];
